import React from "react";
import MathApp from "./MathApp.jsx";
import "./index.css";

function App() {
  return (
    <div className="App">
      <MathApp />
    </div>
  );
}

export default App;
